/**
 * The app's OWN hosts: they serve the marketing site and the app, never a customer's site. Any other host
 * (an agency's CNAME) serves that agency's published website — the server relaxes CSP for it, the client
 * routes it to the site renderer. One list, so a first-party host can never be mistaken for a customer
 * site (and handed the relaxed CSP) on one side only.
 */
export const APP_HOSTS = new Set(['reptree.io', 'www.reptree.io', 'localhost', '127.0.0.1']);
/** Whether a request's hostname is a customer's custom domain rather than one of ours. */
export const isCustomSiteHost = (hostname) => !APP_HOSTS.has(hostname.toLowerCase()) && !hostname.toLowerCase().endsWith('.onrender.com');
//# sourceMappingURL=hosts.js.map